import { render, staticRenderFns } from "./sidebaritem.vue?vue&type=template&id=65b6c8c4&scoped=true&"
import script from "./sidebaritem.vue?vue&type=script&lang=js&"
export * from "./sidebaritem.vue?vue&type=script&lang=js&"
import style0 from "./sidebaritem.vue?vue&type=style&index=0&id=65b6c8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b6c8c4",
  null
  
)

export default component.exports